import React from "react";

const Marquee = ({ items, accent = "#E5FF00" }) => {
  // duplicate for seamless loop
  const list = [...items, ...items];

  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-[#080808]"
      data-testid="marquee"
    >
      <div className="marquee-track py-7 md:py-12">
        {list.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-8 md:gap-16 px-5 md:px-10 shrink-0"
          >
            <span className="font-display text-4xl sm:text-5xl md:text-7xl lg:text-8xl tracking-tighter text-outline whitespace-nowrap">
              {item}
            </span>
            <span
              className="w-2.5 md:w-3 h-2.5 md:h-3 shrink-0 rounded-full"
              style={{ background: accent }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
